export default "__VITE_PUBLIC_ASSET__137d8d87__"